import { deleteWithAuth } from './http.service';
import { DELETE_LINK_LIBRARY_URL } from './url.service';

export const deleteLinkLibrary = (id) => deleteWithAuth(
  DELETE_LINK_LIBRARY_URL(id)
);
